import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { MenuAccessService } from 'src/app/core/navigation/menu-access.service';

async function checkMenuAccess(state: RouterStateSnapshot) {
  const router = inject(Router);
  const menuAccess = inject(MenuAccessService);
  const normalizedUrl = menuAccess.normalizeUrl(state.url);
  const hasToken = !!(localStorage.getItem('token') || sessionStorage.getItem('token'));

  if (hasToken) {
    await menuAccess.ensureMenuSnapshot();
  }

  if (menuAccess.hasAccess(state.url)) {
    return true;
  }

  return router.createUrlTree(['/access-denied'], {
    queryParams: {
      from: normalizedUrl || 'home'
    }
  });
}

export const menuAccessGuard: CanActivateFn = async (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  checkMenuAccess(state);

export const menuAccessChildGuard: CanActivateChildFn = async (_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  checkMenuAccess(state);
